import { menuItems, formatPortionLabel } from '@/data/foods';
import { useFoodCatalog } from './useFoodCatalog';

export interface TopSeller {
    id: number | string;
    name: string;
    item_name?: string;
    price: number | string;
    description?: string;
    image_path?: string;
    item_image?: string;
    is_available?: boolean;
    available?: boolean;
    canAddToCart?: boolean;
    is_top_seller?: number;
    portion_quantity?: number;
    portion_label?: string;
    food_unit?: string;
    [key: string]: unknown;
}

const useTopSellersData = () => {
    const { data: foodUpdates, isLoading, isError, error } = useFoodCatalog();

    let mergedData: TopSeller[] = [];

    if (foodUpdates && foodUpdates.size > 0) {
        mergedData = menuItems.map(staticItem => {
            const update = foodUpdates.get(Number(staticItem.id));
            if (!update) return null;

            const portionQty = update.portion !== undefined ? update.portion : staticItem.portion_quantity;
            const foodUnit = update.food_unit || staticItem.food_unit;
            const portionLabel = formatPortionLabel(portionQty, foodUnit) || staticItem.portion_label;

            const resolvedParams = {
                price: Number(update.price !== null && update.price !== undefined ? update.price : staticItem.price),
                preparation_days: Number(update.preparation_days !== undefined ? update.preparation_days : (staticItem.food_parameters?.preparation_days ?? 2)),
                portion_quantity: portionQty ?? 0,
                daily_capacity: Number(update.daily_capacity !== undefined ? update.daily_capacity : (staticItem.food_parameters?.daily_capacity ?? 0)),
                weight_percentage: Number(update.weight_percentage !== undefined ? update.weight_percentage : (staticItem.food_parameters?.weight_percentage ?? 0)),
                is_top_seller: Boolean(update.is_top_seller !== undefined ? update.is_top_seller : (staticItem.food_parameters?.is_top_seller ?? false)),
                food_unit: foodUnit || 'pcs',
                portion_label: portionLabel || '',
            };

            return {
                ...staticItem,
                ...update,
                name: staticItem.name || staticItem.item_name || '',
                price: update.price !== null && update.price !== undefined ? update.price : staticItem.price,
                is_available: update.is_available ?? false,
                available: update.available ?? false,
                canAddToCart: update.canAddToCart ?? false,
                is_top_seller: update.is_top_seller ?? 0,
                portion_quantity: portionQty,
                food_unit: foodUnit,
                portion_label: portionLabel,
                food_parameters: resolvedParams,
            } as TopSeller;
        }).filter((item): item is TopSeller => item !== null);
    } else {
        const filtered = menuItems.filter(item => item.is_top_seller);
        mergedData = (filtered.length > 0 ? filtered : menuItems.slice(0, 5)) as unknown as TopSeller[];
    }

    const data = mergedData
        .sort((a, b) => (Number(b.is_top_seller) || 0) - (Number(a.is_top_seller) || 0))
        .slice(0, 5);

    return {
        isLoading,
        isError,
        error,
        data,
    };
};

export default useTopSellersData;
